import React, { useRef, useState, useEffect } from 'react';
import './Login.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function Login() {
  const formRef = useRef();
  const [adminData, setAdminData] = useState(null);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect if already logged in
    if (localStorage.getItem('isLoggedIn') === 'true') {
      navigate('/admin/dashboard');
    }
  }, [navigate]);

  useEffect(() => {
    // Fetch admin data
    axios.get('/data/data.json')
      .then((response) => {
        console.log('Fetched admin data:', response.data.admin);
        setAdminData(response.data.admin);
      })
      .catch((error) => {
        console.error('Error fetching admin data:', error);
      });
  }, []);

  // If data is not yet fetched, show a loading message
  if (!adminData) {
    return <div style={{ textAlign: 'center', color: 'white' }}>Loading Login page...</div>;
  }

  const USERNAME = adminData.username;
  const PASSWORD = adminData.password;

  const handleLogin = (e) => {
    e.preventDefault();
    if (username === USERNAME && password === PASSWORD) {
      localStorage.setItem('isLoggedIn', 'true'); // Set a flag in localStorage
      navigate('/admin/dashboard');
    } else {
      setError('Invalid username or password');
    }
  };

  const handleFocus = (e) => {
    const parent = e.target.parentNode;
    parent.classList.add('focus');
  };

  const handleBlur = (e) => {
    const parent = e.target.parentNode;
    if (e.target.value === "") {
      parent.classList.remove('focus');
    }
  };

  return (
    <div>
      <h2 data-heading="Hey, Pratyush" className="section__title">Login</h2>

      <div className="admin__container container grid">
        <div className="admin__content">
          <form ref={formRef} onSubmit={handleLogin} className="admin__form">
            <div className="input__container">
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                name="username"
                className="input"
                onFocus={handleFocus}
                onBlur={handleBlur}
                required
              />
              <label>Username</label>
              <span>Username</span>
            </div>

            <div className="input__container">
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                name="password"
                className="input"
                onFocus={handleFocus}
                onBlur={handleBlur}
                required
              />
              <label>Password</label>
              <span>Password</span>
            </div>

            {error && <p style={{ color: 'red' }}>{error}</p>}
            <button type="submit" className="button">
              <i className="uil uil-navigator button__icon"></i> Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
